/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchRequest { 
    schemas?: Array<string>;
    attributes?: string;
    excludedAttributes?: string;
    filter?: string;
    sortBy?: string;
    sortOrder?: string;
    startIndex?: number;
    count?: number;
}

